import React, { useState } from "react";
import { Logo } from "../Logo";
import { JoinTeamModal } from "./JoinTeamModal";

export const LandingHeader = ({ onCheckEligibility }) => {
  const [joinOpen, setJoinOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 mt-4">
        <div className="flex items-center justify-between rounded-full backdrop-blur-xl bg-white/70 border border-white/60 shadow-sm px-5 py-3">
          <Logo />
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#052F24]/70">
            <a href="#how" className="hover:text-[#052F24] transition-colors">How it works</a>
            <a href="#why" className="hover:text-[#052F24] transition-colors">Why us</a>
            <a href="#faq" className="hover:text-[#052F24] transition-colors">FAQ</a>
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => setJoinOpen(true)}
              data-testid="join-team-btn"
              className="text-[#052F24] text-sm font-bold px-4 py-2.5 rounded-full border border-[#052F24]/15 hover:bg-[#052F24]/5 transition-colors"
            >
              Join our team
            </button>
            <button
              onClick={onCheckEligibility}
              data-testid="header-cta"
              className="bg-[#052F24] text-[#DFFF00] text-sm font-bold px-5 py-2.5 rounded-full hover:bg-[#0a3d30] transition-colors"
            >
              Check eligibility
            </button>
          </div>
        </div>
      </div>
      <JoinTeamModal open={joinOpen} onOpenChange={setJoinOpen} />
    </header>
  );
};
